/**
 * Seller submission result panel — success and error states (Sell Your Car M7).
 */
import { Link } from "react-router-dom";

/**
 * @param {{
 *   presentation: ReturnType<import('./sellerSubmissionSubmitPresentation').resolveSellerSubmissionSubmitPresentation>,
 *   resultHeadingRef?: import('react').RefObject<HTMLElement|null>,
 *   onRetry?: () => void,
 *   onSubmitAnother?: () => void,
 * }} props
 */
export default function SellerSubmissionResultPanel({
  presentation,
  resultHeadingRef,
  onRetry,
  onSubmitAnother,
}) {
  if (!presentation.showResultPanel || !presentation.title) {
    return null;
  }

  const role = presentation.variant === "success" ? "status" : "alert";
  const variantClass =
    presentation.variant === "success"
      ? "sell-car-form__result--success"
      : presentation.variant === "warning"
        ? "sell-car-form__result--warning"
        : "sell-car-form__result--error";

  return (
    <div
      className={`sell-car-form__result ${variantClass}`.trim()}
      role={role}
      aria-live="polite"
      data-testid="seller-submission-result-panel"
    >
      <p ref={resultHeadingRef} className="sell-car-form__result-title" tabIndex={-1}>
        {presentation.title}
      </p>
      {presentation.body ? <p className="sell-car-form__result-body">{presentation.body}</p> : null}

      {presentation.steps?.length ? (
        <ul className="sell-car-form__result-steps">
          {presentation.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ul>
      ) : null}

      {presentation.links?.length ? (
        <div className="sell-car-form__result-links">
          {presentation.links.map((link) => (
            <Link key={link.href} to={link.href} className="sell-car-form__result-link">
              {link.label}
            </Link>
          ))}
        </div>
      ) : null}

      <div className="sell-car-form__result-actions">
        {presentation.showRetry ? (
          <button type="button" className="sell-car-page__btn sell-car-page__btn--primary" onClick={onRetry}>
            {presentation.retryLabel}
          </button>
        ) : null}
        {presentation.showSubmitAnother ? (
          <button
            type="button"
            className="sell-car-page__btn sell-car-page__btn--secondary sell-car-form__result-reset"
            onClick={onSubmitAnother}
          >
            {presentation.submitAnotherLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}
